module.exports = __webpack_public_path__ + "assets/img/icon_acknowledge_game.43aa3c22.png";